import {createSlice} from "@reduxjs/toolkit";
import {isEmpty} from "../_helpers/commonFunctions";

let incrementalId = 0;

const initialState = [
    /*
    {
        tabType: "start",
        key: "0",
        displayName: "", // Not required
        activity: true/false, // If user had activity. When this is true and tabType is in CHECK_FOR_ACTIVITY array, then notify user before closing
        incrementalId: 0, // The user's incremental id for selection. Used when user closes an existing tab, in order to navigate him to the previous he selected
        scrollPosition: 0,
    }
     */
];

export const TabsSlice = createSlice({
    name: "Tabs",
    initialState,
    reducers: {
        // Add a tab to the state
        addTab: (state, { payload }) => {
            incrementalId++;
            if (typeof payload === "string") {
                return [...state, { tabType: payload, key: String(Date.now()), incrementalId, scrollPosition: 0 }]
            } else {
                return [...state, { tabType: payload.tabType, key: payload.key, displayName: payload.displayName, incrementalId, scrollPosition: 0 }]
            }
        },

        // Delete a tab from the state
        removeTab: (state, { payload }) => {
            if (typeof payload === "string") {
                return state.filter((item) => item.tabType !== payload);
            } else {
                return state.filter((item) => item.key !== payload.key);
            }
        },

        // Tag a tab as activity has happened, in order to notify user before closing it
        tabActivity: (state, { payload }) => {
            const idx = state.findIndex((el) => el.key === payload.key);
            if (idx >= 0 && !state[idx].activity) state[idx].activity = true;
        },

        // Remove activity tag from a tab, in order to avoid user notification when closing it
        // Used when user saves etc...
        tabInActivity: (state, { payload }) => {
            const idx = state.findIndex((el) => el.key === payload.key);
            if (idx >= 0 && state[idx].activity) state[idx].activity = false;
        },

        // Tab's incremental id based on user selection
        tabIncremental: (state, {payload}) => {
            if (payload >= 0) {
                incrementalId++;
                state[payload].incrementalId = incrementalId;
            }
        },

        // payload should have, "key" and "scrollPosition"
        tabScrollPosition: (state, {payload}) => {
            const idx = state.findIndex((el) => el.key === payload.key);
            if (idx >= 0) state[idx].scrollPosition = payload.scrollPosition;
        },

        // Re-order tabs
        reOrderTabs: (state, action) => {
            const [draggedTabIndex, dropIndex] = action.payload;
            if (draggedTabIndex === null || draggedTabIndex === dropIndex) return;
            const [removedTab] = state.splice(draggedTabIndex, 1);
            state.splice(dropIndex, 0, removedTab);
        },

        // Auto update tab displayName when saving an object
        autoUpdateTab: (state, {payload}) => {
            const openIndex = state.findIndex((el) => !isEmpty(el.displayName) && String(el.key).includes(payload._id));
            if (openIndex >= 0) state[openIndex].displayName = payload.name;
        }
    },
})

export const {
    addTab,
    removeTab,
    tabActivity,
    tabInActivity,
    tabIncremental,
    tabScrollPosition,
    reOrderTabs,
    autoUpdateTab,
} = TabsSlice.actions;

// Update Tab Active Index
export const ActiveMainTabSlice = createSlice({
    name: "Active Main Tab",
    initialState: 0,
    reducers: {
        updateActiveMainTab: (state, action) => {
            return action.payload;
        },
    },
})

export const {updateActiveMainTab} = ActiveMainTabSlice.actions;

export const collapsedSideMenu = createSlice({
    name: "collapsed Side Menu",
    initialState: 0,
    reducers: {
        updateCollapsedMenuId: (state, payload) => {
            return state = payload;
        },
    },
})

export const {updateCollapsedMenuId} = collapsedSideMenu.actions;
